import React, { useState } from "react";
import { withRouter } from "../../Helpers/Common"; //Include Home
import { motion } from "framer-motion";
//import './AboutusMobile.css';
import Profilemenu from "../Profile_menu/Profilemenu";
import { SVGIcons } from "../../Helpers/Common";
import { Metadata } from "../Metadata/Metadata";
import { Link } from "react-router-dom";
import HeaderEth from "../common/HeaderEth";
import FooterEth from "../common/FooterEth";
var SVGIcon = "";
SVGIcons().then((resultData) => (SVGIcon = resultData));

export default function AboutusDesktop() {

  const { VirsionCheckData, userData } = useState();

  return (
    <>
      <motion.div
        className=""
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 1 }}
        key="1"
      >
        <Metadata page="ABOUT-US" />
        <HeaderEth />
        <main>
          <div className="mobilewebview">
            <section className="mb-0">
              <div className="homeBanner">
                <div className="innerBanner mb-0">
                  <div className="policy-title">
                    <h1>About <span className="red"> us</span></h1>
                  </div>
                </div>
              </div>
            </section>
            <section>
              <div className="temp37">
                <div className="temp37-inn">
                  <p className="about-us-head">ETHIOTELECOM</p>
                  <p>
                    We are Africa’s pioneering telecom company with more than 129 years of immense
                    experience. Today, here we are standing bold and BIG yet for another golden milestone
                    leading Ethiopia and Ethiopians towards a bright future. We are always on the front
                    line to streamline the overall effort of our people, carry their vision and support
                    them in any way to transform their lives.
                  </p>
                  <p>Please visit our website: <a href="https://www.ethiotelecom.et/" target="_blank">www.ethiotelecom.et</a> to learn more about us. </p>
                  <ol>
                    <li><p>&#x2022; For any of your enquiries related with our product and services, our social media advisors are ready to assist you via DM/Inbox or comments.</p></li>
                    <li><p>&#x2022; For any of your account related queries, please reach us via inbox/DM. If you have a general query on any of our product and services, you can send us via DM/Inbox or comment.</p></li>
                  </ol>
                  <p>
                    We highly value any of our customers’ feedback and believe it will serve as the most important input to improve our service delivery, enhance their experience and develop our business afterwards.
                  </p>
                  <p>We want to say thank you for stopping by to read about us! </p>
                  <p className="about-us-head">DOCUBAY</p>
                  <p>Headquartered in Mumbai, the financial capital of world’s largest internet market, DocuBay is a global membership video-on-demand platform designed specifically for streaming documentaries from around the world. Developed to cater to factual entertainment viewers, the platform offers mainstream, engaging, relevant and insightful content across genres from leading creators across the globe. </p>
                  <p>With One Tribe, Many Stories as the brand’s tagline, DocuBay brings together real stories from around the globe for its viewers to stream. DocuBay is available across all devices and is accessible in more than 150 countries, with its team spread between US, UK, Europe and Asia. Viewers can become a member to enjoy premium documentaries with Daily, Weekly & Monthly Plans. DocuBay also offers a FAST Channel. </p>
                </div>
              </div>
            </section>
          </div>
        </main>
        <FooterEth />
      </motion.div >
    </>
  );
  // }
}